import {
  datePartWithoutTimeYYYYMMDD,
  type IBulkCloneBookingsDto,
  type IBulkCloneBookingsForm,
  type TimeZoneEnum,
} from "@ryde/shared";

/** The ends go as the calendar days picked, read in the company timezone, so no clock change or browser offset moves them. */
export const buildBulkCloneBookingsPayload = ({
  ids,
  form,
  timezone,
}: {
  ids: number[];
  form: IBulkCloneBookingsForm & { dateFrom: TDateISO; dateTo: TDateISO };
  timezone: TimeZoneEnum;
}): IBulkCloneBookingsDto => {
  const payload: IBulkCloneBookingsDto = {
    ids,
    dateFrom: datePartWithoutTimeYYYYMMDD(form.dateFrom, timezone),
    dateTo: datePartWithoutTimeYYYYMMDD(form.dateTo, timezone),
    dayGroup: form.dayGroup ?? [],
    dayType: form.dayType ?? [],
  };
  return payload;
};

/** Compares the same company-timezone days the payload sends, so the form can't accept a range the API gets reversed. */
export const isBulkCloneDateRangeValid = ({
  dateFrom,
  dateTo,
  timezone,
}: {
  dateFrom?: TDateISO;
  dateTo?: TDateISO;
  timezone: TimeZoneEnum;
}): boolean => {
  if (!dateFrom || !dateTo) {
    return true;
  }
  // YYYY-MM-DD strings compare in date order.
  return (
    datePartWithoutTimeYYYYMMDD(dateFrom, timezone) <=
    datePartWithoutTimeYYYYMMDD(dateTo, timezone)
  );
};
